"use strict";

exports.__esModule = true;
exports.TPA_EXPERIMENTS = exports.BM_EXPERIMENTS = void 0;
var _bm = require("./bm");
exports.BM_EXPERIMENTS = _bm.BM_EXPERIMENTS;
var _tpa = require("./tpa");
exports.TPA_EXPERIMENTS = _tpa.TPA_EXPERIMENTS;
//# sourceMappingURL=index.js.map